import(/* webpackMode: "eager" */ "/codebuild/output/src2706285732/src/lawgue-website-v2/src/app/components/templates/Contact.tsx")